export default __webpack_public_path__ + "static/media/cladding18.d50e595a.jpeg";